import Swiper from 'swiper';
import { A11y, Autoplay, Navigation } from 'swiper/modules';
const videoSlidersList = document.querySelectorAll('.swiper-video-slider');

document.addEventListener('DOMContentLoaded', () => mountSlidersByElementsList(videoSlidersList));

const mountSlidersByElementsList = nodeList => {
  nodeList.forEach(element => {
    const isAutoPlay = element.classList.contains('autoplay');
    const isLoop = element.classList.contains('loop');

    const swiper = new Swiper(element, {
      modules: [Navigation, A11y, Autoplay],
      slidesPerView: 1,
      spaceBetween: 32,
      loop: isLoop,
      autoplay: isAutoPlay,
      navigation: {
        nextEl: '.btn-carousel-next',
        prevEl: '.btn-carousel-prev',
      },
      breakpoints: {
        700: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
    });

    const onTab = event => {
      if (event.key === 'Tab') {
        if (swiper.params.loop) {
          swiper.params.loop = false;
          swiper.loopDestroy();
        }
        element.removeEventListener('keydown', onTab);
      }
    };

    element.addEventListener('keydown', onTab);

    const videoElements = element.querySelectorAll('.youtube');
    videoElements.forEach(el => {
      el.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          el.click();
        }
      });
    });
  });
};
